import { Box, EmptyView, Loader, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import ActionsMenu from '../../comps/ActionMenu/ActionsMenu'
import { NewTable } from '../../comps/NewTable'
import { transactionScreenStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getCustomColumnWidth, getErrorMessage, getWidth, useWindowDimensions } from '../../util/util'
import { CreatePayout } from './CreatePayout'
import { styles } from './styles'

const PayoutHistory = () => {
  const { fetchPayoutHistory, selectedDateInfo, updateSelectedDate, mid } = useStores((root) => ({
    fetchPayoutHistory: root.payoutHistory.fetchPayoutHistory,
    selectedDateInfo: root.payoutHistory.selectedDate,
    updateSelectedDate: root.payoutHistory.updateSelectedDate,
    mid: root.user.selectedMid,
  }))

  const [payoutHistory, payoutHistoryHandler] = useLazyApiData(fetchPayoutHistory)

  const [listData, setListData] = useState([])
  const apis = [payoutHistoryHandler]
  const [loadingState, setLoadingState] = useState(false)
  const [fieldSettingVisible, setFieldSettingVisible] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const errorState = getErrorMessage(apis)
  const emptyState = listData.length === 0 && !loadingState

  const viewPortWidth = useWindowDimensions()
  useEffect(() => {
    if (payoutHistoryHandler?.state === 'fulfilled') {
      setListData(payoutHistoryHandler?.data?.data)
    }
  }, [payoutHistoryHandler?.data?.data, payoutHistoryHandler?.state])

  useEffect(() => {
    payoutHistory(mid)
  }, [mid, payoutHistory])

  const handleExport = (type: string, _path: string, _selectedDateInfo: any) => {
    // exportPayoutHistory()
  }

  const fetchData = () => {
    payoutHistory(mid)
    setLoadingState(true)
  }

  const getEmptyMessage = (): string => {
    return listData.length === 0 ? transactionScreenStrings.noRecords : transactionScreenStrings.empty
  }
  const scrollViewStyle = () => {
    if (listData.length === 0) {
      return styles.emptyContainer
    }
    return styles.tableContainer(loadingState)
  }

  const handleRetry = () => {
    fetchData()
  }

  const onRowPress = (info: any) => {
    setSelectedItem(info)
  }

  const scrollStyle = scrollViewStyle()
  return (
    <Box {...styles.container}>
      <Box {...styles.flexRowView}>
        <TextNew title={'Payouts History'} {...styles.titleText} />
        <CreatePayout setSelectedItem={setSelectedItem} valueSelected={selectedItem} />
      </Box>
      <ActionsMenu
        path={Routes.PAYOUTS_HISTORY}
        handleExport={handleExport}
        fetchDetailOfPath={fetchData}
        fieldSettingVisible={fieldSettingVisible}
        filterVisible={filterVisible}
        selectedDateInfo={selectedDateInfo}
        updateSelectedDate={updateSelectedDate}
        maxRange={31}
        setFieldSettingVisible={setFieldSettingVisible}
        setFilterVisible={setFilterVisible}
        showFieldSettingsAndFilters={false}
        hideFieldSettings={false}
        hideExportButton={false}
        showCalendarOnRight={true}
        showExportOnRight={false}
      />
      <Spacer direction={'vertical'} size={32} />
      <EmptyView
        onRetry={handleRetry}
        isLoading={loadingState}
        error={errorState}
        emptyMessage={getEmptyMessage()}
        loadingMessage={'fetching records..'}
        hide={!emptyState}
      />
      <ModBox show={payoutHistoryHandler.state === 'pending'}>
        <Loader color="PRIMARY" />
        <SpacerNew size={8} />
      </ModBox>
      <ModBox
        show={!filterVisible && !fieldSettingVisible && listData?.length > 0}
        {...scrollStyle}
        nativeID={'scroll-horizontal-Table'}
        f={1}>
        <NewTable
          data={listData}
          onRowClick={onRowPress}
          rowHeight={48}
          headerHeight={64}
          hide={!(!loadingState && !errorState && !getEmptyMessage())}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={getWidth(viewPortWidth > 1200 ? viewPortWidth - 288 : viewPortWidth, listData?.[0])}
          headerRowKeys={{
            date: 'Date/Time',
            transactionId: 'Transaction Id/Rrn',
            amount: 'Amount',
            beneficiaryName: 'Beneficiary',
            method: 'Method',
            utr: 'UTR',
            status: 'Status',
          }}
        />
      </ModBox>
    </Box>
  )
}

export default PayoutHistory
